
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 17.45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.636 0a.818.818 0 00-.818.818v1.91H2.455c-1.045 0-1.91.864-1.91 1.908v8.728c0 1.044.865 1.909 1.91 1.909h13.09c1.045 0 1.91-.865 1.91-1.91V4.637a1.923 1.923 0 00-1.91-1.909h-1.363V.818A.818.818 0 0013.364 0a.818.818 0 00-.819.818v1.91h-7.09V.817A.818.818 0 004.636 0zM2.455 4.364h13.09c.16 0 .273.112.273.272v8.728a.26.26 0 01-.273.272H9.763c-.148-1.816-1.639-3.272-3.49-3.272-1.852 0-3.343 1.456-3.49 3.272h-.328a.261.261 0 01-.273-.272V4.636a.26.26 0 01.273-.272zm3.818.545a2.467 2.467 0 00-2.455 2.455 2.467 2.467 0 002.455 2.454 2.467 2.467 0 002.454-2.454 2.467 2.467 0 00-2.454-2.455zM10.636 6a.818.818 0 00-.818.818.818.818 0 00.818.818h3.273a.818.818 0 00.818-.818A.818.818 0 0013.91 6zm-4.363.545c.461 0 .818.357.818.819a.806.806 0 01-.818.818.806.806 0 01-.818-.818c0-.462.356-.819.818-.819zm4.363 2.728a.818.818 0 00-.818.818.818.818 0 00.818.818h3.273a.818.818 0 00.818-.818.818.818 0 00-.818-.818zM6.273 12c.957 0 1.648.725 1.796 1.636H4.477c.147-.91.839-1.636 1.796-1.636zM.818 15.818a.818.818 0 00-.818.818.818.818 0 00.818.819h16.364a.818.818 0 00.818-.819.818.818 0 00-.818-.818z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    